import { Component, Inject, Input, NgZone, OnInit, AfterViewInit } from '@angular/core';
import { ConstantsService } from '../services/constants.service';
import { environment } from '../../environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CacheService } from '../services/cache.service';
import { Meta, Title } from '@angular/platform-browser';
import { Auth, Hub } from 'aws-amplify';
import { gsap } from 'gsap';
import { Router } from '@angular/router';
import { GetPaymentService } from '../services/get-payment.service';
import { MatDialog } from '@angular/material/dialog';
import { PaymentComponent } from '../payment/payment.component';
import { DOCUMENT } from '@angular/common';
import Player from '@vimeo/player';
import { MapSearchComponent } from '../map-search/map-search.component';
import { UserService } from '../services/user.service';
import { SharedMixpanelService } from '../services/shared-mixpanel.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, AfterViewInit {
  public player = null;
  public player1 = null;
  public isSpinning = false;
  public login: boolean;
  public logo = '';
  public bg = '';
  public blurbImg = '';
  public isCampaign = false;
  public campaign = '';
  public campaignConstants = null;
  public isMobile = false;
  public isLogin = null;
  public popupShowed = false;
  public profilePicture = '';
  public userName = '';
  public isLoading = true;
  public campUrl = `/${environment.CAMPAIGN_URL}`;
  date: any;
  today: string;
  expiredate: any;
  date1: any;
  date2: any;
  diffTime: number;
  diffDays: number;
  isPrime: any;
  dataArr: any;
  showhome: boolean;
  memberid: any;
  insideHub: boolean = false;
  @Input() from = '';
  secondTime: boolean = false;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    public constants: ConstantsService,
    private deviceService: DeviceDetectorService,
    private authenticate: CacheService,
    private zone: NgZone,
    private router: Router,
    private paymentService: GetPaymentService,
    public dialog: MatDialog,
    public userService: UserService,
    public title: Title,
    private meta: Meta,
    private mixpanel: SharedMixpanelService
  ) {
    // Used for listening to login events
    Hub.listen("auth", ({ payload: { event, data } }) => {
      this.userService.getUserDataFromDb().then(async data => {
        let picture = (await this.authenticate.getAuthUser()).picture;
        if (!this.secondTime) {
          this.mixpanel.actions.identify(data['email']);
          this.mixpanel.actions.people.set({
            "$name": data['first_name'],
            "$email": data['email'],
            "$avatar": picture,
            "Email": data['userName'],
            "Member Id": data['member_id']
          });
          this.mixpanel.actions.track("Login", {
            "User name": data['userName'],
            "Email": data['email'],
            "Member Id": data['member_id']
          });
        }
        this.secondTime = true;
      })
      if (event === "cognitoHostedUI" || event === "signedIn") {
        this.zone.run(() => this.router.navigate(['/']));
      } else {
      }
    });
    this.logo = constants.WINDOW_SWAP_IMG;
    this.bg = constants.HOME_BG_IMG;
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit(): void {
    this.title.setTitle(this.constants.TITLE.home);
    let data = this.paymentService.var;
    if (data.data === true) {
      this.dialog.open(PaymentComponent, {
        disableClose: true,
        panelClass: 'full-width-dialog',
        maxWidth: '100vw',
        maxHeight: '100vh',
      });
    }

    this.authcall();
    this.loadCampaign();
    this.initialisePlater(this.player, 'vimeo')
    this.initialisePlater(this.player1, 'vimeo1')
  }

  ngAfterViewInit(): void {
      // The section below is commented out because Publift ads need to be removed.
      // const fusetag = window['fusetag'] || (window['fusetag'] = { que: [] });
      //   fusetag.que.push(function () {
      //     fusetag.pageInit({ blockingFuseIds: ['23174194651','23173945071','23197864273','23198728802','23197864045','23197864360'] });
      //   });
      // fusetag.que.push(function () {
      //   fusetag.registerZone('window_incontent_desktop');
      //   fusetag.registerZone('window_incontent_tablet');
      //   fusetag.registerZone('window_incontent_mob');
      //   fusetag.registerZone('window_header_desktop');
      //   fusetag.registerZone('window_header_tablet');
      //   fusetag.registerZone('window_header_mob');
      // });
  }


  initialisePlater(player, id) {
    player = new Player(id, {
      url: `https://player.vimeo.com/video/522685321?h= `,
      responsive: true,
      autoplay: false,
      autopause: false,
      muted: 0,
      height: 400,
      controls: true,
      loop: true,
    });
  }
  public async authcall() {
    this.isSpinning = true;
    this.authenticate
      .getAuthUser()
      .then(async (data) => {
        let { login, picture, userName, given_name, email } = await data;
        this.profilePicture = picture;
        this.userName = email;
        this.isLogin = login;
        this.isLoading = false;
        if (userName !== undefined) {
          localStorage['loginWith'] = userName?.includes('google') || userName?.includes('facebook') ? JSON.stringify('social') : JSON.stringify('email');
        }
        if (login) {
          await this.userService.getUser(false).then(async data => {
            this.isPrime = await data.isPrime;
            this.profilePicture = data.pictureUrl === undefined ? picture : data.pictureUrl;
            this.memberid = data['member_id']
            if (this.isPrime) {
              this.isSpinning = false;
              this.showhome = true;
              if (this.document.getElementById('menu-item') !== null) {
                this.document.getElementById('menu-item').style.display = 'none';
              }
            }
            else if (JSON.parse(localStorage.getItem('fromPricing'))) {
              this.router.navigate(['/payment'])
            } else {
              this.isSpinning = false;
            }
            if (JSON.parse(localStorage.getItem('fromwindowBookmark'))) {
              this.router.navigate(['/Window'])
            }
            localStorage['fromPricing'] = JSON.stringify(false);
            localStorage['fromwindowBookmark'] = JSON.stringify(false);
          })
          await this.paymentService.getUserData(userName, given_name)
        }
        else {
          this.isPrime = false
          this.isSpinning = false;
          localStorage['fromPricing'] = JSON.stringify(false)
          localStorage['fromwindowBookmark'] = JSON.stringify(false);
          localStorage['fromwindowBookmark-CurrentVideo'] = JSON.stringify([]);
        }
      })
  }

  public async loadCampaign() {
    if (typeof environment.CAMPAIGN_NAME !== 'undefined' && environment.CAMPAIGN_TYPE === 'campaign') {
      const constants = await import(
        `../../${environment.CAMPAIGN_NAME}/constant.js`
      );
      const isMobile = this.deviceService.isMobile();
      this.blurbImg = `../../${environment.CAMPAIGN_NAME}/campaign-blurb.png`;
      this.isCampaign = true;
      this.campaign = environment.CAMPAIGN_NAME;
      this.campaignConstants = constants.default;
    }
    this.authenticate.animateUI('easeinout');
  }
  onMenuOpen() {
    document.getElementById('mobile-menu').style.display = 'block';
    let mobileMenu = gsap.timeline();
    mobileMenu.from(['#mobile-menu'], {
      delay: 0,
      opacity: 0,
      x: -1500,
      duration: 0.8,
      ease: 'power3.outIn',
      stagger: {
        amount: 0.4,
      },
    });
  }

  onClickOpenWindow() {
    this.paymentService.videoTag.next(false);
    this.router.navigateByUrl('/Window');
  }
  onMenuClose() {
    document.getElementById('mobile-menu').style.display = 'none';
  }
  onMouseOverAvatar() {
    document.getElementById('user-menu').style.display = 'block';
  }
  onMouseLeaveAvatar() {
    document.getElementById('user-menu').style.display = 'none';
  }
  async logout() {
    try {
      await Auth.signOut()
      this.userService.userData = undefined;
      this.userService.isFirstCall = true;
      this.mixpanel.actions.reset()
      this.zone.run(() => this.router.navigate(['/login']));
    } catch (error) {
      if (error.code === 'NotAuthorizedException') {
        console.error('Access Token has been revoked. Please log in again.');
        localStorage.clear();
        // Optionally redirect to login or show a message to the user
        this.router.navigate(['/login']);
      } else {
        console.error('Error signing out:', error);
      }
    }
  }
  goToLink(url: string) {
    window.open(url, "_blank");
  }
  Takemetoprime() {
    this.router.navigate(['/pricing']);
  }
  getvalue(event) {
    let value = event;

    this.paymentService.videoTag.next({
      value,
      fromHome: true,
      userName: this.userName
    });
    this.router.navigateByUrl('/Window');
  }
  onClickSearch() {
    let data = {};
    data['windowHeader'] = false;
    data['prime'] = this.isPrime;
    let dialogRef = this.dialog.open(MapSearchComponent, {
      data: data,
      panelClass: 'full-width-dialog',
      maxWidth: '100vw',
      maxHeight: '100vh',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (!result.isWindowClose) {
        this.paymentService.videoTag.next({
          result,
          fromHome: true
        });
        this.router.navigateByUrl('/Window');
      }
    });
  }
}
